import { CampaignStatsOption, IncludeExclude } from "../../../utils/types";
import Autocomplete from "../../library/Autocomplete";
import CAMPAIGN_STATS_OPTIONS from "./campaignStatsOptions";

interface CampaignStatsAutocompleteProps {
  onChange: (selected: CampaignStatsOption[]) => void;
  selected: CampaignStatsOption[];
  reactRef?: any;
  disabled?: boolean;
  multiple?: boolean;
  style?: {[key:string]:string};
  useIncludeExclude?: boolean;
  defaultIncludeExclude?: IncludeExclude;
  includeExcludeOnChange?: (newIncludeExclude:IncludeExclude) => void;
  options?: CampaignStatsOption[]; // Allow custom options, fallback to default
}

function CampaignStatsAutocomplete(props: CampaignStatsAutocompleteProps) {
  const labelKeyFunction = (option: CampaignStatsOption) => {
    // Group options by category for better UX
    const categoryLabel = option.category === 'state' ? 'State' : 'Region';
    return `${categoryLabel}: ${option.name}`;
  }

  return (
    <Autocomplete
      id="campaignStatsAutocomplete"
      placeholder="Campaign Stats"
      reactKey="campaignStatsAutocomplete"
      labelKey={labelKeyFunction}
      onChange={props.onChange}
      options={props.options || CAMPAIGN_STATS_OPTIONS}
      selected={props.selected}
      reactRef={props.reactRef}
      disabled={props.disabled}
      useIncludeExclude={props.useIncludeExclude}
      defaultIncludeExclude={props.defaultIncludeExclude}
      includeExcludeOnChange={props.includeExcludeOnChange}
      multiple={props.multiple}
      style={props.style}
      paginate={false}
      maxResults={CAMPAIGN_STATS_OPTIONS.length + 1}
      keepDropdownOpen={true}
    />
  );
}

export default CampaignStatsAutocomplete;